import { isFirefox, isMobile } from 'react-device-detect';

const getZoomLevel = () => {
  // On default zoom (100%), there might be a small difference between outerWidth and innerWidth
  // and we don't want that to afffect the zoom level (e.g. avoid it to be something like 1.01),
  // so we add a small threshold of 50px
  const computedZoomLevel =
    Math.abs(window.outerWidth - window.innerWidth) <= 50
      ? 1
      : Number((window.outerWidth / window.innerWidth).toFixed(2));

  // In Firefox only, outerWidth is not working as expected on zoom so
  // devicePixelRatio is a better solution to identify the zoomLevel
  const zoomLevel =
    isFirefox && !isMobile ? window.devicePixelRatio : computedZoomLevel;

  return zoomLevel;
};

export default getZoomLevel;
